import type { AuthUser } from "./authApi";

export type RoleId = "admin" | "user" | "demo";

export type UiAccess = "all" | "admin";

export const ROLE_LABELS: Record<RoleId, string> = {
  admin: "Admin",
  user: "User",
  demo: "Demo",
};

export const VIEWER_ROLES: RoleId[] = ["admin", "user", "demo"];

export function hasPermission(user: AuthUser | null, key: string): boolean {
  if (!user) return false;
  const perms = user.permissions ?? [];
  return perms.includes("*") || perms.includes(key);
}

export function isAdmin(user: AuthUser | null): boolean {
  if (!user) return false;
  return (user.roles ?? []).includes("admin") || hasPermission(user, "dashboard.admin");
}

export function canManageUsers(user: AuthUser | null): boolean {
  return isAdmin(user);
}

export function canSyncMqttCatalog(user: AuthUser | null): boolean {
  return isAdmin(user);
}

export function canBackfillChargerMv(user: AuthUser | null): boolean {
  return isAdmin(user);
}

export function canClearWsHistory(user: AuthUser | null): boolean {
  return isAdmin(user) || hasPermission(user, "api.clear_history");
}

/** fcr-core module/service commands and allocation writes on the FCR tab. */
export function canControlFcrCore(user: AuthUser | null): boolean {
  return isAdmin(user);
}

export function rolesForAccess(access: UiAccess): RoleId[] {
  return access === "admin" ? ["admin"] : VIEWER_ROLES;
}

export function accessLabel(access: UiAccess): string {
  return access === "admin" ? "Admin only" : "All signed-in users";
}
